import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPalette, FaGraduationCap, FaTrophy, FaUsers } from 'react-icons/fa';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import logo from './assets/images.jpg';
import academyImage from './assets/2.jpg';
import studentWork from './assets/3.jpg';
import aboutss1 from './assets/about1.jpg';
import aboutss2 from './assets/about2.jpg';
import Navbar from './Navbar';
import Footer from './Footer';
import SEO from './components/SEO';

const AboutAcademy = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('mission');

  const tabs = [
    { id: 'mission', label: 'Our Mission' },
    { id: 'values', label: 'Our Values' },
    { id: 'approach', label: 'Our Approach' }
  ];

  return (
    <>
      <SEO
        title="About Academy"
        description="Learn about Donzi Art Academy's mission, values, and unique approach to art education. Discover how we nurture creativity and artistic excellence in children."
        keywords="art academy, art education, children's art, art classes, art workshops, creative learning, art programs, Donzi Art Academy, art for children"
      />
      <div className="min-h-screen w-full bg-white text-gray-800 font-sans">
        <Navbar />

        {/* Hero Section */}
        <section className="pt-32 pb-16 px-4 bg-gradient-to-b from-[#00B7F1]/10 to-white">
          <div className="container mx-auto">
            <h1 className="text-4xl md:text-5xl font-light mb-6 tracking-wide">
              ABOUT <span className="font-normal" style={{ color: '#00B7F1' }}>DONZI ART ACADEMY</span>
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl font-light tracking-wide">
              Nurturing artistic excellence through structured training and creative exploration
            </p>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16 px-4">
          <div className="container mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <img
                  src={aboutss1}
                  alt="Donzi Art Academy"
                  className="w-full h-auto rounded-lg shadow-lg"
                />
              </div>
              <div>
                <h2 className="text-3xl font-light mb-6 tracking-wide">
                  SHAPING THE <span className="font-normal" style={{ color: '#00B7F1' }}>FUTURE</span> OF ART
                </h2>
                <p className="text-gray-600 mb-6 font-light tracking-wide">
                  At Donzi Art Academy, we believe in the transformative power of art education. Our academy is dedicated to providing a nurturing environment where young artists can develop their skills, express their creativity, and build a strong foundation in visual arts.
                </p>
                <p className="text-gray-600 font-light tracking-wide">
                  Through our comprehensive curriculum and expert guidance, we help students discover their unique artistic voice while mastering fundamental techniques that stand the test of time.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Tabs Section */}
        <section className="py-16 px-4 bg-gray-50">
          <div className="container mx-auto">
            <div className="max-w-4xl mx-auto">
              {/* Tab Navigation */}
              <div className="flex flex-wrap gap-4 mb-8">
                {tabs.map((tab) => (
                  <div
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`px-6 py-3 text-sm uppercase tracking-wider transition-all duration-200 cursor-pointer ${activeTab === tab.id
                      ? 'bg-[#00B7F1] text-white'
                      : 'bg-white text-gray-700 hover:bg-gray-100'
                      }`}
                  >
                    {tab.label}
                  </div>
                ))}
              </div>

              {/* Tab Content */}
              <div className="bg-white p-8 rounded-lg shadow-sm">
                {activeTab === 'mission' && (
                  <div>
                    <h3 className="text-2xl font-light mb-4 tracking-wide">Our Mission</h3>
                    <p className="text-gray-600 font-light tracking-wide">
                      To provide exceptional art education that nurtures creativity, builds technical skills, and fosters artistic growth in children. We aim to create a supportive environment where students can explore their artistic potential and develop a lifelong appreciation for the arts.
                    </p>
                  </div>
                )}

                {activeTab === 'values' && (
                  <div>
                    <h3 className="text-2xl font-light mb-4 tracking-wide">Our Values</h3>
                    <ul className="space-y-4">
                      <li className="flex items-start gap-3">
                        <span className="text-[#00B7F1] mt-1">•</span>
                        <p className="text-gray-600 font-light tracking-wide">
                          Excellence in art education and teaching methodologies
                        </p>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#00B7F1] mt-1">•</span>
                        <p className="text-gray-600 font-light tracking-wide">
                          Individual attention and personalized learning approaches
                        </p>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#00B7F1] mt-1">•</span>
                        <p className="text-gray-600 font-light tracking-wide">
                          Creative freedom balanced with structured learning
                        </p>
                      </li>
                    </ul>
                  </div>
                )}

                {activeTab === 'approach' && (
                  <div>
                    <h3 className="text-2xl font-light mb-4 tracking-wide">Our Approach</h3>
                    <p className="text-gray-600 font-light tracking-wide mb-4">
                      Our teaching methodology combines traditional art techniques with contemporary approaches, ensuring students develop both technical skills and creative thinking abilities.
                    </p>
                    <ul className="space-y-4">
                      <li className="flex items-start gap-3">
                        <span className="text-[#00B7F1] mt-1">•</span>
                        <p className="text-gray-600 font-light tracking-wide">
                          Structured curriculum with progressive skill development
                        </p>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#00B7F1] mt-1">•</span>
                        <p className="text-gray-600 font-light tracking-wide">
                          Regular exhibitions and showcase opportunities
                        </p>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-[#00B7F1] mt-1">•</span>
                        <p className="text-gray-600 font-light tracking-wide">
                          Small class sizes for personalized attention
                        </p>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 px-4 bg-[#00B7F1] text-white">
          <div className="container mx-auto text-center">
            <h2 className="text-3xl font-light mb-6 tracking-wide">JOIN OUR <span className="font-normal" style={{ color: '#C3D83B' }}>ARTISTIC COMMUNITY</span></h2>
            <p className="text-white/90 mb-8 max-w-2xl mx-auto font-light tracking-wide">
              Start your artistic journey with Donzi Art Academy and discover your creative potential in our inspiring learning environment.
            </p>
            <div
              onClick={() => navigate('/register')}
              className="bg-[#C3D83B] hover:bg-[#A5C020] text-black font-medium rounded px-8 py-4 text-lg transition-all uppercase tracking-wide flex items-center gap-2 mx-auto cursor-pointer"
            >
              Register Now
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-16 px-4 sm:py-24 bg-white">
          <div className="container mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <div className="lg:w-1/2">
                <img
                  src={aboutss1}
                  alt="Donzi Art Academy building"
                  className="w-full h-auto object-cover rounded-lg shadow-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h2 className="text-3xl sm:text-4xl font-light mb-6 tracking-wide">
                  OUR <span className="font-normal" style={{ color: '#C3D83B' }}>MISSION</span>
                </h2>
                <p className="text-gray-600 mb-6 font-light tracking-wide text-lg">
                  At Donzi Art Academy, we believe that artistic talent thrives when creativity meets discipline.
                  Our mission is to provide a structured yet inspiring environment where students of all ages can
                  develop their technical skills while discovering their unique artistic voice.
                </p>
                <div className="p-6 mb-8 border-l-4 border-[#00B7F1] bg-[#C3D83B]/5 rounded-r-lg">
                  <p className="text-gray-700 italic font-light tracking-wide text-lg">
                    "We don't just teach art techniques - we cultivate artists who can think critically,
                    express themselves authentically, and contribute meaningfully to Egypt's cultural landscape."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 px-4 bg-[#00B7F1]/10">
          <div className="container mx-auto">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
              {[
                {
                  icon: <FaPalette className="text-4xl mb-4 mx-auto" style={{ color: '#00B7F1' }} />,
                  number: "13+",
                  label: "Years of Excellence"
                },
                {
                  icon: <FaGraduationCap className="text-4xl mb-4 mx-auto" style={{ color: '#00B7F1' }} />,
                  number: "2000+",
                  label: "Students Trained"
                },
                {
                  icon: <FaTrophy className="text-4xl mb-4 mx-auto" style={{ color: '#00B7F1' }} />,
                  number: "12+",
                  label: "Awards Won"
                },
                {
                  icon: <FaUsers className="text-4xl mb-4 mx-auto" style={{ color: '#00B7F1' }} />,
                  number: "31+",
                  label: "EXHIBITIONS"
                }
              ].map((stat, index) => (
                <div key={index} className="p-8 bg-white rounded-lg shadow-sm">
                  {stat.icon}
                  <div className="text-3xl font-light mb-2" style={{ color: '#C3D83B' }}>{stat.number}</div>
                  <div className="text-gray-600 font-light tracking-wide uppercase text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Student Work Section */}
        <section className="py-16 px-4 bg-gray-50">
          <div className="container mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <div className="lg:w-1/2">
                <h2 className="text-3xl sm:text-4xl font-light mb-6 tracking-wide">
                  STUDENT <span className="font-normal" style={{ color: '#C3D83B' }}>ACHIEVEMENTS</span>
                </h2>
                <p className="text-gray-600 mb-6 font-light tracking-wide text-lg">
                  Our students regularly win national competitions and gain admission to prestigious art programs
                  worldwide. The structured training at Donzi Art Academy prepares students to excel in both
                  academic and professional artistic pursuits.
                </p>
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" stroke="#00B7F1" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <div className="font-light tracking-wide">Acceptance to top art schools.</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" stroke="#00B7F1" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <div className="font-light tracking-wide">Winners of national and international competitions.</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" stroke="#00B7F1" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <div className="font-light tracking-wide">Showcasing work in local and international art exhibitions.</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" stroke="#00B7F1" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <div className="font-light tracking-wide">Complete intensive workshops in various art mediums.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:w-1/2">
                <img
                  src={aboutss2}
                  alt="Student artwork examples"
                  className="w-full h-auto object-cover rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Locations Section */}
        <section className="py-16 px-4 sm:py-24 bg-white">
          <div className="container mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-light mb-4 tracking-wide">OUR <span className="font-normal" style={{ color: '#00B7F1' }}>LOCATIONS</span></h2>
              <p className="text-gray-600 max-w-2xl mx-auto font-light tracking-wide text-lg">
                Modern facilities designed for artistic learning
              </p>
            </div>
            <div class="flex justify-center">
              <div className="grid md:grid-cols-1 gap-8 w-1/2 justify-center">
                {[
                  {
                    location: "New Cairo Branch",
                    phone: "01021676660",
                  }
                ].map((branch, index) => (
                  <div key={index} className="flex justify-center p-8 border border-gray-200 rounded-lg hover:shadow-lg transition duration-300">
                    <FiMapPin className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#00B7F1' }} />
                    <h3 className="text-xl font-light tracking-wide mx-4 uppercase" style={{ color: '#C3D83B' }}>New Cairo   </h3>

                    <FiMapPin className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#00B7F1' }} />
                    <h3 className="text-xl font-light tracking-wide mx-4 uppercase" style={{ color: '#C3D83B' }}>6th October   </h3>
                    <FiMapPin className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#00B7F1' }} />
                    <h3 className="text-xl font-light tracking-wide mx-4 uppercase" style={{ color: '#C3D83B' }}>UpTown Cairo    </h3>

                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default AboutAcademy;